// Catalogo farmaci/sintomi della sezione Salute.
// I tipi vivono in types.ts; qui stanno etichette, ordini e normalizzazioni condivise
// tra db (migrazione), domain (scrittura/riepiloghi), sync (payload legacy) e UI.
import type { MedicationKind, SymptomKind } from "./types";

export const MEDICATION_KINDS: MedicationKind[] = ["ipp", "antiacido", "brioschi"];

export const MEDICATION_LABELS: Record<MedicationKind, string> = {
  ipp: "IPP",
  antiacido: "F.Tidina",
  brioschi: "Brioschi"
};

// Sinonimi storici: il pantoprazolo era l'unico farmaco registrato.
export function normalizeMedicationKind(value: unknown): MedicationKind {
  if (value === "ipp" || value === "antiacido" || value === "brioschi") {
    return value;
  }
  // Righe legacy (locali o di backup) con medication "pantoprazolo" o valori sconosciuti.
  return "ipp";
}

export const SYMPTOM_KINDS: SymptomKind[] = [
  "bruciore",
  "nodo_stomaco",
  "fermentazione",
  "dormito_seduto",
  "episodio_gastrico"
];

export const SYMPTOM_LABELS: Record<SymptomKind, string> = {
  bruciore: "Bruciore",
  nodo_stomaco: "Nodo stomaco",
  fermentazione: "Fermentazione",
  dormito_seduto: "Dormito seduto",
  episodio_gastrico: "Episodio gastrico"
};

// Righe sintomi nell'andamento: l'episodio gastrico ha gia' i suoi indicatori
// nella heatmap (pallini blu), una riga dedicata sarebbe doppia informazione.
export const SYMPTOM_TREND_KINDS: SymptomKind[] = SYMPTOM_KINDS.filter(
  (kind) => kind !== "episodio_gastrico"
);

// Etichette brevi per la colonna da 38px della heatmap, allineate ai giorni.
export const SYMPTOM_ROW_SHORT_LABELS: Record<SymptomKind, string> = {
  bruciore: "Bruc",
  nodo_stomaco: "Nodo",
  fermentazione: "Ferm",
  dormito_seduto: "Sed",
  episodio_gastrico: "Epi"
};

export function symptomLogLabel(log: { symptom?: SymptomKind | null; vomited: boolean }): string {
  if (log.symptom) {
    return SYMPTOM_LABELS[log.symptom];
  }
  return log.vomited ? "Episodio gastrico" : "Malessere";
}
